import { map } from 'rxjs/operators'
import http from '../helpers/http'
import httpDelete from '../helpers/httpDelete'

const getCity = (params:object) => {
    // console.log('get country called')
    // console.log(params ,'param')
    return http({
    method: 'GET',
    url: '/cities/list/search',
    params
    }).pipe(
    map(res => {
        if (res.success) {
        // console.log(res, 'res')
        return res
        } else {
        // console.log(res ,'res')
        throw new Error(res.msg)
        }
    })
    )
}

const addCity =( body : object) => {
    return http({
    method: 'POST',
    url: '/cities',
    body
    }).pipe(
    map(res => {
        if (res.success) {
        return res
        } else {
        throw new Error(res.msg)
        }
    })
    )
}

const updateCity =(body:object) => {
    return http({
    method: 'PUT',
    url: `/cities`,
    body
    }).pipe(
    map(res => {
        if (res.success) {
        // console.log('update user response', res)
        return res
        } else {
        throw new Error(res.msg)
        }
    })
    )
}

const deleteCities = (id : any) => {
    return httpDelete({
      method: 'DELETE',
      url: `/cities/${id}`,
    }).pipe(
      map(res => {
        // console.log(res,'delete response')
        if (res) {
          return res
        } else {
          // console.log(res,'error message')
          throw new Error(res)
        }
      })
    )
  }

const getCityDetail = (id:any) => {
    // TODO: change with real http req
    //return Observable.of(mockData).pipe(map(res => res.find(d => d.id === id)))
}
const cityService = {
    deleteCities,
    addCity,
    getCity,
    getCityDetail,
    updateCity,
}

export default cityService